import React, { useState } from "react";
import "./NavBar1.css";
import HomeSVG1 from "./SVGS/HomeSVG1";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

function NavBar1() {
  const [activeStatus, setactiveStatus] = useState("home");
  const [toggle, settoggle] = useState(true);
  const [open, setopen] = useState(true);
  

  return (
    <div>
      <nav class="navbar navbar-div1 navbar-expand-lg navbar-light ">
        <Link
          class="navbar-brand AJH-logo"
          to="/"
          onClick={() => setactiveStatus("home")}
        >
          {/* <strong>AJH</strong> Accountant */}
          <svg
            width="120"
            height="45"
            viewBox="0 0 122 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M60.6289 32.5382L68.7872 10.4382H75.3681L83.5559 32.5382H76.6914L75.6103 29.295H68.1314L67.0504 32.5382H60.6289ZM71.0438 20.5164L69.5906 24.8407H74.163L72.7747 20.5164L71.9418 17.6749H71.8827C71.5696 18.8446 71.2919 19.7957 71.0438 20.5164Z"
              fill="#3033B5"
            />
            <path
              d="M91.4419 32.9399C88.6831 32.9399 86.6214 32.2192 85.2627 30.7777C83.904 29.3363 83.2246 27.4991 83.2246 25.2779V23.5765H89.1912V25.3369C89.1912 26.8197 89.8528 27.5641 91.1702 27.5641C92.4462 27.5641 93.0842 26.8433 93.0842 25.4019V10.4382H99.5411V25.6146C99.5411 27.6349 99.0331 29.2418 98.0288 30.4351C96.5874 32.1069 94.3898 32.9399 91.4419 32.9399Z"
              fill="#3033B5"
            />
            <path
              d="M102.046 32.5382V10.4382H108.503V18.5374H115.302V10.4382H121.759V32.5382H115.302V23.8837H108.503V32.5382H102.046Z"
              fill="#3033B5"
            />
            <path
              d="M0 46.5333L27.5526 0L35.2441 13.1914L27.1095 27.2217H16.8718L5.27539 46.5333H0Z"
              fill="#3033B5"
            />
            <path
              d="M20.1154 31.2979H25.5208L16.37 46.5333H10.9233L20.1154 31.2979Z"
              fill="#3033B5"
            />
            <path
              d="M43.4612 5.31084L45.6706 6.66956L22.0938 46.8582H27.6881L49.6227 8.70174L51.9975 10.1727V0L43.4612 5.31084Z"
              fill="#FFB532"
            />
            <path
              d="M43.6974 28.3027L33.1348 46.8582H54.4667L43.6974 28.3027Z"
              fill="#3033B5"
            />
            <path
              d="M62.2062 37.1816H64.2679L65.8452 46.8522H64.327L64.0493 44.9323V44.9618H62.3243L62.0467 46.8522H60.6348L62.2062 37.1816ZM63.8662 43.6503L63.1868 38.8712H63.1573L62.4956 43.6503H63.8662Z"
              fill="black"
            />
            <path
              d="M67.8474 46.3736C67.4634 45.9601 67.2744 45.3752 67.2744 44.6191V39.4205C67.2744 38.6643 67.4634 38.0795 67.8474 37.6659C68.2314 37.2524 68.7867 37.0457 69.5134 37.0457C70.24 37.0457 70.7953 37.2524 71.1793 37.6659C71.5633 38.0795 71.7523 38.6643 71.7523 39.4205V40.4425H70.3168V39.3259C70.3168 38.7293 70.0628 38.428 69.5547 38.428C69.0467 38.428 68.7926 38.7293 68.7926 39.3259V44.7313C68.7926 45.3221 69.0467 45.6174 69.5547 45.6174C70.0628 45.6174 70.3168 45.3221 70.3168 44.7313V43.2544H71.7523V44.625C71.7523 45.3811 71.5633 45.966 71.1793 46.3795C70.7953 46.793 70.24 46.9998 69.5134 46.9998C68.7867 46.9939 68.2314 46.7871 67.8474 46.3736Z"
              fill="black"
            />
            <path
              d="M73.9973 46.3736C73.6134 45.9601 73.4243 45.3752 73.4243 44.6191V39.4205C73.4243 38.6643 73.6134 38.0795 73.9973 37.6659C74.3813 37.2524 74.9366 37.0457 75.6633 37.0457C76.3899 37.0457 76.9452 37.2524 77.3292 37.6659C77.7132 38.0795 77.9022 38.6643 77.9022 39.4205V40.4425H76.4667V39.3259C76.4667 38.7293 76.2127 38.428 75.7046 38.428C75.1966 38.428 74.9425 38.7293 74.9425 39.3259V44.7313C74.9425 45.3221 75.1966 45.6174 75.7046 45.6174C76.2127 45.6174 76.4667 45.3221 76.4667 44.7313V43.2544H77.9022V44.625C77.9022 45.3811 77.7132 45.966 77.3292 46.3795C76.9452 46.793 76.3899 46.9998 75.6633 46.9998C74.9366 46.9939 74.3813 46.7871 73.9973 46.3736Z"
              fill="black"
            />
            <path
              d="M80.1523 46.3559C79.7565 45.9306 79.5557 45.3339 79.5557 44.56V39.4737C79.5557 38.6998 79.7565 38.1031 80.1523 37.6778C80.5481 37.2525 81.1212 37.0398 81.8655 37.0398C82.6098 37.0398 83.1829 37.2525 83.5787 37.6778C83.9745 38.1031 84.1753 38.6998 84.1753 39.4737V44.56C84.1753 45.3339 83.9745 45.9306 83.5787 46.3559C83.1829 46.7813 82.6098 46.9939 81.8655 46.9939C81.1212 46.9939 80.5481 46.7813 80.1523 46.3559ZM82.6571 44.6605V39.3792C82.6571 38.7412 82.3913 38.4281 81.8714 38.4281C81.3456 38.4281 81.0857 38.7471 81.0857 39.3792V44.6605C81.0857 45.2985 81.3456 45.6116 81.8714 45.6116C82.3913 45.6116 82.6571 45.2926 82.6571 44.6605Z"
              fill="black"
            />
            <path
              d="M86.5565 46.3619C86.1666 45.9425 85.9775 45.3399 85.9775 44.5601V37.1816H87.4958V44.6723C87.4958 45.0032 87.5607 45.2454 87.6966 45.3931C87.8325 45.5407 88.0215 45.6116 88.2697 45.6116C88.5178 45.6116 88.7068 45.5348 88.8427 45.3931C88.9786 45.2454 89.0435 45.0032 89.0435 44.6723V37.1816H90.5086V44.5601C90.5086 45.3458 90.3136 45.9425 89.9297 46.3619C89.5457 46.7813 88.9785 46.9881 88.246 46.9881C87.5017 46.994 86.9405 46.7813 86.5565 46.3619Z"
              fill="black"
            />
            <path
              d="M92.4106 37.1816H94.3188L95.7956 42.971H95.8252V37.1816H97.178V46.8522H95.6184L93.793 39.7928H93.7634V46.8522H92.4106V37.1816V37.1816Z"
              fill="black"
            />
            <path
              d="M100.333 38.564H98.7437V37.1816H103.44V38.564H101.851V46.8581H100.333V38.564Z"
              fill="black"
            />
            <path
              d="M105.544 37.1816H107.605L109.183 46.8522H107.664L107.387 44.9323V44.9618H105.662L105.384 46.8522H103.972L105.544 37.1816ZM107.198 43.6503L106.518 38.8712H106.489L105.827 43.6503H107.198Z"
              fill="black"
            />
            <path
              d="M110.736 37.1816H112.644L114.121 42.971H114.15V37.1816H115.503V46.8522H113.944L112.118 39.7928H112.089V46.8522H110.736V37.1816V37.1816Z"
              fill="black"
            />
            <path
              d="M118.653 38.564H117.063V37.1816H121.76V38.564H120.171V46.8581H118.653V38.564Z"
              fill="black"
            />
          </svg>
        </Link>

        <button
          class="navbar-toggler mr-sm-4 mr-2"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div
          class="collapse navbar-collapse mt-lg-0 mt-4"
          id="navbarSupportedContent"
        >
          <ul class="navbar-nav navbar-ul">
            <li
              className={`${
                activeStatus === "home"
                  ? "nav-item active home1"
                  : "nav-item home1"
              }`}
            >
              <Link
                class="nav-link"
                to="/"
                onClick={() => {setactiveStatus("home")}}
              >
                Home <span class="sr-only">(current)</span>
              </Link>
            </li>
            <li
              className={`${
                activeStatus === "about"
                  ? "nav-item active home1"
                  : "nav-item home1"
              }`}
            >
              <Link
                class="nav-link"
                to="/about-us"
                onClick={() => setactiveStatus("about")}
              >
                About Us
              </Link>
            </li>

            {/* <li className={`${activeStatus === "services" ? "nav-item dropdown active home1": "nav-item dropdown home1"}`}>
              <Link
              
                class="nav-link dropdown-toggle"
                role="button"
                data-toggle="dropdown"
                aria-expanded="false"
                onClick={()=>setactiveStatus("services")}
              >
                Services
              </Link>
              <div class="dropdown-menu">
                <Link class="dropdown-item" to="/accounting" >
                  Accounting
                </Link>
                <Link class="dropdown-item" to="/tax" >
                  Tax
                </Link>
              </div>
            </li> */}
            <li
            onClick={() => setactiveStatus("services")}
              className={`${
                activeStatus === "services"
                  ? "nav-item dropdown active home1"
                  : "nav-item dropdown home1"
              }`}
              // onClick={() => setopen(!open)}
            >
              <Link
                class="nav-link dropdown-toggle"
                role="button"
                // data-toggle="dropdown"
                aria-expanded="false"
                // onClick={() => setopen(!open)}
                to="/accounting"
              >
                Accounting Services
              </Link>
              {/* <div class={`${open ? "dropdown-menu":"dropdown-menu show"}`}> */}
              <div class="dropdown-menu">
                <HashLink
                  class="dropdown-item mt-0"
                  to="/accounting#statutory"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={600}
                >
                  Statutory Accounts
                </HashLink>
                <HashLink
                  class="dropdown-item"
                  to="/accounting#profit"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={600}
                >
                  Profit & Loss Account
                </HashLink>
                <HashLink
                  class="dropdown-item"
                  to="/accounting#balance"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={600}
                >
                  Balance sheet
                </HashLink>
                <HashLink
                  class="dropdown-item"
                  to="/accounting#cashflow"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={600}
                >
                  Cash Flow Statements
                </HashLink>
              </div>
            </li>
            <li
            onClick={() => setactiveStatus("services1")}
              className={`${
                activeStatus === "services1"
                  ? "nav-item dropdown active home1"
                  : "nav-item dropdown home1"
              }`}
            >
              <Link
                class="nav-link dropdown-toggle"
                role="button"
                // data-toggle="dropdown"
                aria-expanded="false"
                // onClick={() => setopen(!open)}
                to="/tax"
              >
                Tax Services
              </Link>
              <div class="dropdown-menu">
                <HashLink
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={600}
                  class="dropdown-item mt-0"
                  to="/tax#individualTaxServices"
                >
                  Individual Tax Services
                </HashLink>
                <HashLink
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={600}
                  class="dropdown-item"
                  to="/tax#corporationTaxReturn"
                >
                  Corporation Tax Return
                </HashLink>
                <HashLink
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={600}
                  class="dropdown-item"
                  to="/tax#valueAddedTax"
                >
                  Value Added Tax (VAT)
                </HashLink>
              </div>
            </li>
            <li
              className={`${
                activeStatus === "contact"
                  ? "nav-item active home1"
                  : "nav-item home1"
              }`}
            >
              <Link
                class="nav-link"
                to="/contact-us"
                onClick={() => setactiveStatus("contact")}
              >
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
      </nav>














      <nav class="navbar mobile-navbar-div1 d-flex d-lg-none navbar-expand-lg navbar-light ">
        <button
          class="navbar-toggler mr-sm-4 mr-2"
          type="button"
          // data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={() => settoggle(!toggle)}
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <Link
          class="navbar-brand AJH-logo text-center ml-0 mx-auto"
          to="/"
          onClick={() => setactiveStatus("home")}
        >
          <svg
            width="50"
            height="44"
            viewBox="0 0 38 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 32.1944L19.0624 0L24.3838 9.12657L18.7559 18.8335H11.6729L3.64981 32.1944H0Z"
              fill="#3033B5"
            />
            <path
              d="M13.9173 21.6533H17.657L11.3261 32.194H7.55774L13.9173 21.6533Z"
              fill="#3033B5"
            />
            <path
              d="M30.0693 3.67433L31.5979 4.61437L15.2861 32.4191H19.1566L34.3322 6.02035L35.9752 7.03804V0L30.0693 3.67433Z"
              fill="#FFB532"
            />
            <path
              d="M30.2326 19.5811L22.9248 32.4187H37.6834L30.2326 19.5811Z"
              fill="#3033B5"
            />
          </svg>
        </Link>

        <a href="tel:+44 01204 840303" class="btn nav-btn2 d-lg-none">
          <svg
            className="mr-2 call-svg2"
            width="28"
            height="28"
            viewBox="0 0 10 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.08311 8.03198L6.98418 6.1236C6.88497 6.03342 6.75459 5.98533 6.62058 5.98947C6.48657 5.99361 6.35941 6.04967 6.26595 6.1458L5.03035 7.41651C4.73294 7.35971 4.13501 7.17331 3.51954 6.55939C2.90406 5.9434 2.71766 5.34393 2.66241 5.04859L3.93209 3.81248C4.02834 3.71908 4.08448 3.59191 4.08863 3.45786C4.09277 3.32381 4.04459 3.19341 3.95429 3.09425L2.04642 0.99586C1.95608 0.896391 1.83052 0.836056 1.69642 0.827668C1.56231 0.81928 1.43021 0.863501 1.32819 0.950938L0.207726 1.91184C0.118457 2.00143 0.0651745 2.12067 0.0579872 2.24694C0.0502421 2.37603 -0.0974314 5.43377 2.27361 7.80582C4.34207 9.87375 6.93306 10.025 7.64665 10.025C7.75095 10.025 7.81497 10.0219 7.83201 10.0209C7.95827 10.0138 8.07744 9.96032 8.1666 9.87065L9.127 8.74969C9.21478 8.64799 9.25933 8.516 9.25113 8.3819C9.24293 8.2478 9.18263 8.12223 9.08311 8.03198Z"
              fill="white"
            />
          </svg>

          <p className="call-btn">Call Us</p>
        </a>

        <div
          class={`${
            toggle
              ? "navbar-collapse mobile-navbar-div2"
              : "navbar-collapse mobile-navbar-div2 show"
          } `}
          id="navbarSupportedContent"
        >
          <ul class="navbar-nav mx-auto">
            <li
              className={`${
                activeStatus === "home"
                  ? "nav-item mobile-nav-item active home1"
                  : "nav-item mobile-nav-item home1"
              }`}
            >
              <Link
                class="nav-link"
                to="/"
                onClick={() => {setactiveStatus("home"); settoggle(!toggle)}}
              >
                Home <span class="sr-only">(current)</span>
              </Link>
            </li>
            <li
              className={`${
                activeStatus === "about"
                  ? "nav-item mobile-nav-item active home1"
                  : "nav-item mobile-nav-item home1"
              }`}
            >
              <Link
                class="nav-link"
                to="/about-us"
                onClick={() =>{ setactiveStatus("about"); settoggle(!toggle)}}
              >
                About Us
              </Link>
            </li>

            <li
            onClick={() => setactiveStatus("services")}
              className={`${
                activeStatus === "services"
                  ? "nav-item mobile-nav-item dropdown active home1"
                  : "nav-item mobile-nav-item dropdown home1"
              }`}
            >
              <Link
                class="nav-link dropdown-toggle"
                role="button"
                // data-toggle="dropdown"
                aria-expanded="false"
                to="/accounting"
              >
                Accounting
              </Link>
              <div class="dropdown-menu">
                <HashLink
                  class="dropdown-item mobile-drop-item"
                  to="/accounting#statutory"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={600}
                  onClick={() => settoggle(!toggle)}

                >
                  Statutory Accounts
                </HashLink>
                <HashLink
                  class="dropdown-item mobile-drop-item"
                  to="/accounting#profit"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={600}
                  onClick={() => settoggle(!toggle)}
                >
                  Profit & Loss Account
                </HashLink>
                <HashLink
                  class="dropdown-item mobile-drop-item"
                  to="/accounting#balance"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={600}
                  onClick={() => settoggle(!toggle)}
                >
                  Balance sheet
                </HashLink>
                <HashLink
                  class="dropdown-item mobile-drop-item"
                  to="/accounting#cashflow"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={600}
                  onClick={() => settoggle(!toggle)}
                >
                  Cash Flow Statements
                </HashLink>
              </div>
            </li>
            <li
            onClick={() => setactiveStatus("services1")}
              className={`${
                activeStatus === "services1"
                  ? "nav-item mobile-nav-item dropdown active home1"
                  : "nav-item mobile-nav-item dropdown home1"
              }`}
            >
              <Link
                class="nav-link dropdown-toggle"
                role="button"
                // data-toggle="dropdown"
                aria-expanded="false"
                to="/tax"
              >
                Tax
              </Link>
              <div class="dropdown-menu">
                <HashLink
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={600}
                  class="dropdown-item mobile-drop-item"
                  to="/tax#individualTaxServices"
                  onClick={() => settoggle(!toggle)}

                >
                  Individual Tax Services
                </HashLink>
                <HashLink
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={600}
                  class="dropdown-item mobile-drop-item"
                  to="/tax#corporationTaxReturn"
                  onClick={() => settoggle(!toggle)}
                >
                  Corporation Tax Return
                </HashLink>
                <HashLink
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={600}
                  class="dropdown-item mobile-drop-item"
                  to="/tax#valueAddedTax"
                  onClick={() => settoggle(!toggle)}
                >
                  Value Added Tax (VAT)
                </HashLink>
              </div>
            </li>
            <li
              className={`${
                activeStatus === "contact"
                  ? "nav-item mobile-nav-item active home1"
                  : "nav-item mobile-nav-item home1"
              }`}
            >
              <Link
                class="nav-link"
                to="/contact-us"
                onClick={() => {setactiveStatus("contact"); settoggle(!toggle)}}
              >
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}

export default NavBar1;
